import React from 'react'
import { Carousel } from 'react-responsive-carousel'
import RaisedButton from 'material-ui/RaisedButton'
import { Link } from 'react-router'
import heroBannerConfig from '../../configs/hero-banner-config'

const HeroBanner = () => {
    const carouselItems = Object.keys(heroBannerConfig).map((key, index) => {
      const {button, description, image, title, link} = heroBannerConfig[key];

      const linkIsInternal = link.charAt(0) === '/'

      return (
        <div key={index} className="carousel-item">
          <div className="carousel-content-container">
          <div className="hero-image" style={{backgroundImage: `url(${image})`}}></div>
          <h2 className="hero-header">{title.toUpperCase()}</h2>
            <div className="carousel-description">
              {description}
              <div className="button-container">
              {linkIsInternal ?
                <Link to={link}>
                  <RaisedButton
                    backgroundColor="none"
                    style={{ backgroundColor: 'none', marginTop: '10px', marginBottom: '5px', width: '200px'}}
                    label={button}
                    className="mm-button"
                  />
                </Link> :
                  <RaisedButton
                    backgroundColor="none"
                    className="mm-button"
                    href={link}
                    label={button}
                    style={{ backgroundColor: 'none', marginTop: '10px', marginBottom: '5px', width: '200px'}}
                    target="_blank"
                  />
              }
              </div>
            </div>
          </div>
        </div>
      )
    });

    return (
    <div className="hero-container">
      <Carousel 
        axis="horizontal"
        className="carousel-container"
        infiniteLoop={true}
        showThumbs={false}
        showArrows={true}
        showStatus={false}>
        {carouselItems}
        </Carousel>
      </div>
    );
}

export default HeroBanner



// WEBPACK FOOTER //
// ./src/components/Home/HeroBanner.js